"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const PanelObjectsBase_3d_1 = __importDefault(require("../classes/PanelObjectsBase.3d"));
class Panel extends PanelObjectsBase_3d_1.default {
    constructor() {
        super();
        this.type = 'Panel';
    }
}
exports.default = Panel;
